module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "PEP"
  }, [_vm._v("From the impression of a foot in mud or clay, experts can precisely re-create not only the foot, but the species, gait, height, weight, and likely age of its owner. By an analogous, but exponentially more complex procedure, we can use the methods demonstrated in this paper to re-create not only the generative linguistic capacity, but the intellectual, emotional, and cultural complex in which it is embedded.")]), _vm._v(" "), _c('p', {
    staticClass: "PEPC"
  }, [_vm._v("    —Y"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("URII ")]), _vm._v("O"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("LEGOVICH ")]), _vm._v("M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ALEVIN")]), _vm._v(","), _c('span', {
    staticClass: "ePub-SC"
  }), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Proceedings of the All-Union Soviet Academy of Sciences, Anthology of Closed Sessions")]), _vm._v(", June–October 1946")]), _vm._v(" "), _c('p', {
    staticClass: "PEP"
  }, [_vm._v("For Books are not absolutely dead things, but doe contain a potencie of life in them to be as active as that soule was whose progeny they are; nay they do preserve as in a violl the purest efficacie and extraction of that living intellect that bred them. I know they are as lively, and as vigorously productive, as those fabulous Dragons teeth; and being sown up and down, may chance to spring up armed men.")]), _vm._v(" "), _c('p', {
    staticClass: "PEPC"
  }, [_vm._v("    —J"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("OHN ")]), _vm._v("M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ILTON")]), _vm._v(", "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Areopagitica")])]), _vm._v(" "), _c('p', {
    staticClass: "PEPV"
  }, [_vm._v("And this book is—instead of my body")]), _vm._v(" "), _c('p', {
    staticClass: "PEPV"
  }, [_vm._v("And this word is—instead of my soul.")]), _vm._v(" "), _c('p', {
    staticClass: "PEPC"
  }, [_vm._v("    —G"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("RIGOR ")]), _vm._v("N"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("AREKATSI")]), _vm._v(", "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Book of Grief")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31a4ee5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph1.vue
// module id = 72
// module chunks = 0